import {
    Edit,
    SimpleForm,
    TextInput,
    FormDataConsumer
} from 'react-admin';
import { Box } from '@mui/material';
import { GoogleSpecificFields } from './components/GoogleSpecificFields';
import { ClearAccountDataButtonWrapper } from './components/ClearAccountDataButtonWrapper';
import { transform } from '../../../../helpers';
import { BackButton } from '../../../helperComponents/BackButton';
import { PLATFORMS } from '../../../../config/constants/reportConstants';
import { CustomEditToolbar } from '../../../helperComponents/CustomEditToolbar';

export const PlatformAccountSettingsEdit = (props) => {
  return (
    <>
      <BackButton path="/platform_account_settings" />
      <span className="h4">Edit ad account</span>
      <Edit {...props} title=" " transform={transform('user_access')}>
        <SimpleForm toolbar={<CustomEditToolbar />}>
          <FormDataConsumer>
            {({ formData, form, ...rest }) => (
              <>
              <Box display="flex" alignItems="center">
                <Box flex={1} mr={6}>
                  <TextInput source="platform" label="Platform" disabled={true} />
                </Box>
                {formData.platform === PLATFORMS.GOOGLE && <GoogleSpecificFields />}
              </Box>
              </>
            )}
          </FormDataConsumer>
          <Box display="flex" alignItems="center" mb={2}>
            <Box flex={1} mr={2}>
                <TextInput source="id" label="Internal Account ID" disabled={true} fullWidth />
            </Box>
            <Box sx={{ mt: '-8%' }}>
              <ClearAccountDataButtonWrapper />
            </Box>
          </Box>
          <TextInput source="account_name" label="Account Name" />
          <TextInput source="account_id" label="Account ID" />
        </SimpleForm>
      </Edit>
    </>
  );
};
